export const formatDurationSeconds = (totalSeconds: number): string => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    // Format: 1:23:45h
    return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}h`;
  } else if (minutes > 0) {
    // Format: 12:30m
    return `${minutes}:${seconds.toString().padStart(2, '0')}m`;
  } else {
    // Format: 40s
    return `${seconds}s`;
  }
};
